module.exports = __webpack_public_path__ + "media/images/countryrect/ls-81fed1e69302a6544c544d8a3d3b8ae4.svg";